/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Komu kalendarz pokazuje ofertę w tym stanie — niezależnie od tego, kto pyta. `EVERYONE` — każdy, kto planuje tydzień (od zaakceptowanej do realizacji w górę). `VIEW_ALL_PERMISSION` — sprzedaż i zarząd (uprawnienie do wszystkich statusów). `PROCESS_OWNER` — etap przedsprzedażowy, tylko opiekun procesu. `NOBODY` — oferta nie wchodzi na kalendarz w ogóle. 
 */

export const OfferCalendarAudienceDto = {
    Everyone: 'EVERYONE',
    ViewAllPermission: 'VIEW_ALL_PERMISSION',
    ProcessOwner: 'PROCESS_OWNER',
    Nobody: 'NOBODY',
} as const;

export type OfferCalendarAudienceDto = typeof OfferCalendarAudienceDto[keyof typeof OfferCalendarAudienceDto];



